import { Chip } from "@mui/material";
import {
  BeachAccess as VacationIcon,
  LocalHospital as SickIcon,
  MedicalServices as MedicalIcon,
  ChildCare as MaternityIcon,
  FamilyRestroom as ParentalIcon,
  People as FamilyHolidayIcon,
  DirectionsWalk as EarlyLeaveIcon,
  AccessTime as LateOnShiftIcon,
} from "@mui/icons-material";
import React from "react";
import { AbsenceCategory } from "../../constants/absenceEnums";

interface AbsenceCategoryChipProps {
  category: AbsenceCategory;
  size?: "small" | "medium";
  showIcon?: boolean;
}

const CATEGORY_CONFIG = {
  [AbsenceCategory.Vacation]: {
    label: "Vacation",
    color: "#2196F3", // Blue
    textColor: "#fff",
    icon: <VacationIcon sx={{ fontSize: 16 }} />,
  },
  [AbsenceCategory.SickDays]: {
    label: "Sick Days",
    color: "#FF9800", // Orange
    textColor: "#fff",
    icon: <SickIcon sx={{ fontSize: 16 }} />,
  },
  [AbsenceCategory.MedicalLeave]: {
    label: "Medical Leave",
    color: "#F44336", // Red
    textColor: "#fff",
    icon: <MedicalIcon sx={{ fontSize: 16 }} />,
  },
  [AbsenceCategory.Maternity]: {
    label: "Maternity",
    color: "#E91E63", // Pink
    textColor: "#fff",
    icon: <MaternityIcon sx={{ fontSize: 16 }} />,
  },
  [AbsenceCategory.Parental]: {
    label: "Parental",
    color: "#00BCD4", // Cyan
    textColor: "#fff",
    icon: <ParentalIcon sx={{ fontSize: 16 }} />,
  },
  [AbsenceCategory.FamilyHoliday]: {
    label: "Family Holiday",
    color: "#009688", // Teal
    textColor: "#fff",
    icon: <FamilyHolidayIcon sx={{ fontSize: 16 }} />,
  },
  [AbsenceCategory.EarlyLeave]: {
    label: "Early Leave",
    color: "#3F51B5", // Indigo
    textColor: "#fff",
    icon: <EarlyLeaveIcon sx={{ fontSize: 16 }} />,
  },
  [AbsenceCategory.LateOnShift]: {
    label: "Late On Shift",
    color: "#795548", // Brown
    textColor: "#fff",
    icon: <LateOnShiftIcon sx={{ fontSize: 16 }} />,
  },
};

export const AbsenceCategoryChip: React.FC<AbsenceCategoryChipProps> = ({
  category,
  size = "small",
  showIcon = true,
}) => {
  const config = CATEGORY_CONFIG[category];

  if (!config) {
    return null;
  }

  return (
    <Chip
      label={config.label}
      icon={showIcon ? config.icon : undefined}
      size={size}
      style={{
        backgroundColor: config.color,
        color: config.textColor,
        fontWeight: 500,
      }}
      sx={{
        "& .MuiChip-label": {
          px: showIcon ? 0.5 : 1.5,
          color: config.textColor,
        },
        "& .MuiChip-icon": {
          color: config.textColor,
          ml: showIcon ? 1 : 0,
        },
        "& .MuiChip-root": {
          backgroundColor: config.color,
        },
      }}
    />
  );
};







